import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyD2lj2-hXJWZiIIanmqVjPWctoLqxUHAk8",
  authDomain: "tinder-clone-bca4d.firebaseapp.com",
  databaseURL: "https://tinder-clone-bca4d.firebaseio.com",
  projectId: "tinder-clone-bca4d",
  storageBucket: "tinder-clone-bca4d.appspot.com",
  messagingSenderId: "742955219661",
  appId: "1:742955219661:web:fdb8e230e59f19ef218784"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const database = firebaseApp.firestore();


export default database;